import React from 'react';
import styles from "./installInstruction.module.scss";

const InstallInstruction = () => {
    return (
        <div className={styles.container}>
            <h3 className={styles.title}>Instrucciones de instalación</h3>
            <ul className={styles.instruction_container}>
                <ol className={styles.title_instruction}>Para dispositivos iPhone (iOS)</ol>
                <ol>Abre la página web en Safari</ol>
                <ol>Toca el icono de compartir</ol>
                <ol>Selecciona "Añadir a pantalla de inicio</ol>
                <ol>Toca "Añadir"</ol>
            </ul>
            <ul className={styles.instruction_container}>
                <ol className={styles.title_instruction}>Para dispositivos Android</ol>
                <ol className={styles.font_italic}>(Si no visualiza el boton de INSTALAR)</ol>
                <ol>Abre la página web en Google Chrome</ol>
                <ol>Toque el icono de tres puntos verticales en la esquina superior derecha.</ol>
                <ol>Selecciona "Añadir a pantalla de inicio". </ol>
            </ul>
        </div>
    )
}

export default InstallInstruction;
